import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { GINO_QUERY_KEYS } from "../queryKeys";
import { getGinoAddOns } from "../services/ginoAddOns";

export const useGetGinoAddOns = () => {
  const { i18n } = useTranslation();
  return useQuery({
    queryKey: [...GINO_QUERY_KEYS.GINO_ADDONS, i18n.language],
    queryFn: getGinoAddOns,
  });
};
